/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { Card } from '@els/els-react--card';
// @ts-ignore
import { Button, ButtonWithIcon } from '@els/els-react--button';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
import {
    HSearchContentType,
    HSearchDefaultFacetData,
    HSearchFilters,
} from '../../constants/h-search';
import CardFilterPanel from './components/card-filter-panel/card-filter-panel';
import WarnBanner from '../../components/warn-banner/warn-banner';
import { IHSearchFacetData } from '../../../libs/utils/interfaces/search-interface';
import {
    isPending,
    hasFailed,
    hasSucceeded,
} from '../../../libs/utils/constants/async-status';
import { selectHSearchSkillAsyncStatus } from './search-selector';
import AriaLiveAnnouncer from '../../components/aria-live-announcer/aria-live-announcer';

const LeftFilterPanel = (props: any) => {
    const {
        resultDetails,
        baseClassName,
        toggleOverlay,
        borderWeight,
        onHandleChange,
        selectedContentType,
        searchFacetData,
        totalNoOfRows,
        currentFilters,
        setSelectedRadioOption,
        selectedRadioOption,
        contentTypeLicensedByClient,
        contentTypeLicensedAsyncStatus,
    } = props;

    const previousActiveElementRef = useRef<HTMLElement | null>(null);

    const hSearchAsyncStatus = useSelector(selectHSearchSkillAsyncStatus);
    const [selectedOptionContentType, setSelectedOptionContentType] =
        useState(selectedContentType);
    const [showMoreClickPanelName, setShowMoreClickPanelName] = useState('');
    const [contentTypeFacetData, setContentTypeFacetData] = useState({
        facetName: HSearchDefaultFacetData.facetName,
        facetValues: [HSearchDefaultFacetData.facetValues[0]],
    });
    const [alertCall, setAlertCall] = useState<boolean>(false);
    const [alert, setAlert] = useState('');

    const handleRadioButtonChange = (
        optionName: string,
        optionValue: string
    ) => {
        if (optionName === HSearchFilters.CONTENTTYPE) {
            setSelectedOptionContentType(optionValue);
        }
        onHandleChange(optionName, optionValue);
    };
    const handleReset = () => {
        setSelectedOptionContentType(HSearchContentType.CLINICALSKILLS);
        onHandleChange('Content type', HSearchContentType.CLINICALSKILLS);
        setSelectedRadioOption({
            contentType: HSearchContentType.CLINICALSKILLS,
            ageSpecific: '',
            subType: '',
            speciality: '',
            category: '',
        });
        setAlertCall(true);
    };

    const handleShowMoreLess = (panelName: string, isShowMore: boolean) => {
        setShowMoreClickPanelName(isShowMore ? panelName : '');
    };

    let buttonContent;
    if (totalNoOfRows > 0) {
        buttonContent = `Show ${totalNoOfRows} item${
            totalNoOfRows > 1 ? 's' : ''
        }`;
    } else {
        buttonContent = 'Show all items';
    }

    const resetAlert = () => {
        setAlertCall(false);
        setAlert('');
    };

    const scrollToTop = () => {
        const body = document.getElementById('content-type-select');
        if (!body) return;
        body.scrollTop = 0;
        body.focus();
    };

    useEffect(() => {
        if (alertCall && resultDetails) {
            setAlert(`Filter reset, showing ${resultDetails} Results.`);
        }
    }, [alertCall, resultDetails]);

    useEffect(() => {
        // Focus trap only applies when rendered as a modal overlay
        if (!toggleOverlay) return;

        // Store the previously focused element
        previousActiveElementRef.current =
            document.activeElement as HTMLElement;

        // Set focus to the Card when the component mounts
        const card = document.getElementById('left-filter-panel-card');
        if (card) {
            card.focus();

            // Focus trap handler
            const handleKeyDown = (e: KeyboardEvent) => {
                if (e.key !== 'Tab') return;

                const allFocusableElements: NodeListOf<HTMLElement> =
                    card.querySelectorAll<HTMLElement>(
                        'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])'
                    );
                if (!allFocusableElements.length) return;
                const lastEl: HTMLElement =
                    allFocusableElements[allFocusableElements.length - 1];

                if (e.key === 'Tab' && document.activeElement === lastEl) {
                    e.preventDefault();
                    card.focus();
                }
            };

            card.addEventListener('keydown', handleKeyDown);

            // Clean up on unmount
            return () => {
                card.removeEventListener('keydown', handleKeyDown);
                if (previousActiveElementRef.current) {
                    previousActiveElementRef.current.focus();
                }
            };
        }
    }, []);

    useEffect(() => {
        if (
            hasSucceeded(contentTypeLicensedAsyncStatus) &&
            contentTypeLicensedByClient.PE
        ) {
            setContentTypeFacetData({
                facetName: HSearchDefaultFacetData.facetName,
                facetValues: HSearchDefaultFacetData.facetValues,
            });
        }
    }, [contentTypeLicensedAsyncStatus, contentTypeLicensedByClient]);

    return (
        <Card
            id="left-filter-panel-card"
            borderWeight={borderWeight}
            className={`${baseClassName}__filter-section__card`}
            tabIndex={-1}
        >
            <AriaLiveAnnouncer message={alert} setAlert={resetAlert} />
            <div className={`${baseClassName}__filter-section__card__title`}>
                <h2>Filters</h2>
                <ButtonWithIcon
                    type="link"
                    onClick={handleReset}
                    disabled={!selectedOptionContentType}
                    className={`${baseClassName}__filter-section__card__title__reset-button`}
                    sprite={Icon.Sprites.UNDO}
                >
                    Reset
                </ButtonWithIcon>
                <span
                    className={`${baseClassName}__filter-section__card__title__reset-button-for-mobile`}
                >
                    {selectedOptionContentType && (
                        <ButtonWithIcon
                            type={ButtonWithIcon.Types.LINK}
                            onClick={handleReset}
                            className={`${baseClassName}__filter-section__card__title__reset-button-for-mobile__text`}
                            sprite={Icon.Sprites.UNDO}
                            linkIconSize="s"
                        >
                            Reset
                        </ButtonWithIcon>
                    )}
                    <ButtonWithIcon
                        type={ButtonWithIcon.Types.LINK}
                        onClick={toggleOverlay}
                        id="close-filters"
                        iconOnly
                        className={`${baseClassName}__filter-section__card__title__close-button`}
                        sprite={Icon.Sprites.CLOSE}
                        linkIconSize="xs"
                    >
                        Close filters
                    </ButtonWithIcon>
                </span>
            </div>
            <div className={`${baseClassName}__overlay__content-container`}>
                <CardFilterPanel
                    key="card_content_type"
                    baseClassName={`${baseClassName}`}
                    onHandleChangeOption={handleRadioButtonChange}
                    facetData={contentTypeFacetData}
                    selectedOptionContentType={selectedOptionContentType}
                    isToggleOpen
                    onClickShowMoreLess={handleShowMoreLess}
                    currentFilters={currentFilters}
                    selectedRadioOption={selectedRadioOption}
                    setSelectedRadioOption={setSelectedRadioOption}
                />
                {hasFailed(hSearchAsyncStatus) && (
                    <div
                        className={`${baseClassName}__filter-section-warn-banner`}
                    >
                        <WarnBanner
                            name="filter"
                            size="small"
                            isBannerVisible
                            noCloseIcon
                        />
                    </div>
                )}
                {!hasFailed(hSearchAsyncStatus) &&
                    searchFacetData.length > 0 &&
                    searchFacetData?.map(
                        (facetData: IHSearchFacetData, index: number) => (
                            <CardFilterPanel
                                key={`${index}_type`}
                                baseClassName={`${baseClassName}`}
                                onHandleChangeOption={handleRadioButtonChange}
                                facetData={facetData}
                                selectedOptionContentType={
                                    selectedOptionContentType
                                }
                                isToggleOpen={
                                    facetData?.facetName ===
                                        showMoreClickPanelName ||
                                    showMoreClickPanelName === ''
                                }
                                onClickShowMoreLess={handleShowMoreLess}
                                currentFilters={currentFilters}
                                selectedRadioOption={selectedRadioOption}
                                setSelectedRadioOption={setSelectedRadioOption}
                            />
                        )
                    )}
            </div>
            <div className={`${baseClassName}__mobile-footer`}>
                {isPending(hSearchAsyncStatus) ? (
                    <Loader isVisible isBlocking={false} />
                ) : (
                    <div className={`${baseClassName}__mobile-footer__content`}>
                        <Button
                            size={Button.Sizes.SMALL}
                            type={Button.Types.PRIMARY}
                            onClick={toggleOverlay || (() => {})}
                        >
                            {buttonContent}
                        </Button>
                        <Button
                            type={Button.Types.LINK}
                            onClick={scrollToTop}
                            aria-label="Back to top"
                            className={`${baseClassName}__mobile-footer__content__back-to-top-button`}
                            tabIndex={0}
                        >
                            <Icon
                                sprite={Icon.Sprites.ARROW_UP}
                                isVisible
                                size={Icon.Sizes.XS}
                                color="secondary"
                                className="arrow-up-icon"
                                a11y={{
                                    name: 'Arrow up icon',
                                    description: 'Arrow up icon description',
                                }}
                                aria-hidden="true"
                            />
                        </Button>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default LeftFilterPanel;
